module.exports = __webpack_public_path__ + "static/media/ProximaNovaA-Black.7fc9003b.woff2";